<template>
  <div class="sr-search" :class="search.searchComConfig.simpleMode?'simple':''">
    <div class="search-top-box" v-if="!search.searchComConfig.simpleMode">
      <SrSubTitle :title="search.searchComConfig.title" v-if="search.searchComConfig.title"></SrSubTitle>
      <div class="search-btn-box">
        <template v-for="(item, index) in search.btns">
          <el-button
            v-if="utils.checkCodeInArr(item.permissionCode)"
            style="margin-left: 8px"
            :key="item.name + index"
            size="medium"
            v-bind="item"
            round
            @click="
              (val) => {
                item.click && item.click(val, item);
              }
            "
            >{{ item.name }}</el-button
          >
        </template>
        <slot name="searchBtn"></slot>
      </div>
    </div>
    <div class="search-top-box" v-if="search.searchComConfig.simpleMode && search.searchComConfig.title">
      <SrSubTitle :title="search.searchComConfig.title"></SrSubTitle>
    </div>
    <div class="search-form-box" :class="isShowMoreBtn?'multiple':''">
      <el-form
        :inline="true"
        :ref="search.name || 'form'"
        :model="search.formData"
        @submit.native.prevent
        :label-position="search.searchComConfig.labelPosition"
        :label-suffix="search.searchComConfig.labelSuffix"
        :label-width="search.searchComConfig.labelWidth"
      >
        <div class="simple-box">
          <div class="search-config">
            <el-form-item
              v-for="(item, index) in search.config"
              :key="item.bind"
              :label="search.searchComConfig.simpleMode?'':item.name"
              :prop="item.bind"
              :class="`${(index + 1) % 3 == 0 ? 'thirdItem' : ''} ${
                !((index < (search.searchComConfig.minNum || 3) && !expand) || expand)
                  ? 'none'
                  : ''
              } ${item.className ? item.className : ''}`"
            >
              <!-- input -->
              <el-input
                v-if="item.type == 'text'"
                :class="item.class || 'default_text'"
                :size="search.searchComConfig.size || 'medium'"
                v-model.trim="search.formData[item.bind]"
                v-bind="item"
                :clearable="!isXiAn"
                @keyup.enter.native="onInputEnter"
              >
                <template v-if="isXiAn">
                  <i slot="suffix" class="el-input__icon el-icon-search cursor-pointer" @click="searchFn"></i>
                </template>
                <el-button
                  v-else
                  @click="searchFn"
                  :slot="item.slot ? 'append' : false"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
              <!-- autoComplete -->
              <el-autocomplete
                v-else-if="item.type == 'autoComplete'"
                :class="item.class || 'default_text'"
                :size="search.searchComConfig.size || 'medium'"
                v-model.trim="search.formData[item.bind]"
                v-bind="item"
                clearable
                :fetch-suggestions="querySearch"
              ></el-autocomplete>
              <!-- select -->
              <el-select
                :class="item.class || 'default_select'"
                v-else-if="item.type == 'select'"
                @change="
                  (res) => {
                    item.select.constructor === Function ? item.select() : callSuccessFn(item.select, res);
                  }
                "
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :disabled="item.disabled ? item.disabled : false"
                v-bind="item"
                clearable
                :filterable="item.isHave"
              >
                <el-option
                  v-for="(op, opindex) in (search.enum[item.dataList] || utils.dictionary.getDict(item.dataList))"
                  :key="'op_' + opindex"
                  :label="item.label ? op[item.label] : op.dataName"
                  :value="item.value ? op[item.value] : op.dataValue"
                ></el-option>
              </el-select>
              <!-- data -->
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'date'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :format="item.format || 'yyyy-MM-dd'"
                :value-format="item.format || 'yyyy-MM-dd'"
                v-bind="item"
              ></el-date-picker>
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'datetime'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
                :value-format="item.format || 'yyyy-MM-dd HH:mm:ss'"
                v-bind="item"
              ></el-date-picker>
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'daterange'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :format="item.format || 'yyyy-MM-dd'"
                :value-format="item.format || 'yyyy-MM-dd'"
                v-bind="item"
              ></el-date-picker>
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'month'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                v-bind="item"
              ></el-date-picker>
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'monthrange'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :format="item.format || 'yyyy-MM-dd'"
                :value-format="item.format || 'yyyy-MM-dd'"
                v-bind="item"
              ></el-date-picker>
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'datetimerange'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
                :value-format="item.format || 'yyyy-MM-dd HH:mm:ss'"
                v-bind="item"
              ></el-date-picker>
              <el-date-picker
                :class="item.class || 'default_date_picker'"
                v-else-if="item.type == 'year'"
                :size="search.searchComConfig.size || 'medium'"
                v-model="search.formData[item.bind]"
                :format="item.format || 'yyyy'"
                :value-format="item.format || 'yyyy'"
                @change="
                  (res) => {
                    item.select.constructor === Function ? item.select() : callSuccessFn(item.select, res);
                  }
                "
                v-bind="item"
              ></el-date-picker>
              <el-cascader
                v-else-if="item.type == 'cascader'"
                style="width: 100%"
                :options="search.enum[item.dataList]"
                v-model="search.formData[item.bind]"
                :props="item.props ? item.props : getCascaderProp(item)"
                filterable
                :size="search.searchComConfig.size || 'medium'"
                @change="
                  (res) => {
                    item.select.constructor === Function ? item.select() : callSuccessFn(item.select, res);
                  }
                "
                v-bind="item"
              ></el-cascader>
              <div
                v-else-if="item.type == 'numberArea'"
                :class="item.class || 'default_number_area'"
              >
                <el-input
                  v-model="search.formData[item.startBind]"
                  type="number"
                  :max="item.startMax"
                  :min="item.startMin"
                  :size="search.searchComConfig.size || 'medium'"
                  :placeholder="item.startPlaceholder"
                  @change="handleStartInput"
                ></el-input>
                <span class="interval">-</span>
                <el-input
                  v-model="search.formData[item.endBind]"
                  type="number"
                  :max="item.endMax"
                  :min="item.endMin"
                  :size="search.searchComConfig.size || 'medium'"
                  :placeholder="item.endPlaceholder"
                  @change="handleEndChange"
                ></el-input>
              </div>
            </el-form-item>
          </div>
          <div class="search-flex-right-box" v-if='!search.searchComConfig.noSearchBtn'>
            <div class="search_right_button">
              <sr-popover content="搜索">
                <div @click="searchFn" class="default-btn search-btn">
                  <img :src="searchIcon" />
                </div>
              </sr-popover>
              <sr-popover content="重置">
                <div @click="resetForm" class="default-btn">
                  <img :src="resetIcon" />
                </div>
              </sr-popover>
              <template v-if="isShowMoreBtn">
                <sr-popover :content="expand?'收起':'展开'">
                  <div @click="expand=!expand" class="default-btn">
                    <img :src="expand?upArrowIcon:downArrowIcon" />
                  </div>
                </sr-popover>
              </template>
            </div>
          </div>
        </div>
        <div class="search-btn-box" v-if="search.searchComConfig.simpleMode">
          <template v-for="(item, index) in search.btns">
            <el-button
              v-if="utils.checkCodeInArr(item.permissionCode)"
              style="margin-left: 8px"
              :key="item.name + index"
              size="medium"
              v-bind="item"
              round
              @click="
                (val) => {
                  item.click && item.click(val, item);
                }
              "
              >{{ item.name }}</el-button
            >
          </template>
          <slot name="searchBtn"></slot>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import utils from "../SrUtils/index";

export default {
  name: "SrSearch",
  props: {
    // 搜索组件配置项
    search: {
      type: Object,
    }
  },
  computed: {
    isXiAn() {
      return this.$systemConfig && this.$systemConfig.platform == "XIAN_CLOUD"
    },
    isShowMoreBtn() {
      // 搜索选项大于最小显示的数量时，显示展开/收起按钮
      let isShow = false
      if (this.search) {
        let configCount = 0
        if (this.search.config && this.search.config.length>0) {
          configCount = this.search.config.length
        }
        let minNum = 3
        if (this.search.searchComConfig && this.search.searchComConfig.minNum) {
          minNum = this.search.searchComConfig.minNum
        }
        if (configCount > minNum) {
          isShow = true
        }
      }
      return isShow
    }
  },
  data() {
    return {
      expand: false,
      utils,
      searchIcon: require('../theme-chalk/src/images/icon-search@2x.png'),
      resetIcon: require('../theme-chalk/src/images/icon-reset@2x.png'),
      upArrowIcon: require('../theme-chalk/src/images/icon-up-arrow@2x.png'),
      downArrowIcon: require('../theme-chalk/src/images/icon-down-arrow@2x.png')
    };
  },
  created() {
    if (this.search && this.search.searchComConfig) {
      this.expand = this.search.searchComConfig.searchDefaultExpand;
    }
    // console.log('SrSearch.$dict',this.$dict)
  },
  mounted() {
  },
  destroyed() {
    this.search.formData = {};
  },
  methods: {
    querySearch(queryString, cb) {
      var autoCompleteList = []
      if (this.search && this.search.autoCompleteList) {
        autoCompleteList = this.search.autoCompleteList
      }
      var results = queryString ? autoCompleteList.filter(this.createFilter(queryString)) : autoCompleteList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (target) => {
        return (target.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    onInputEnter() {
      // 输入框敲下回车键
      if (this.search.searchComConfig.enterSearch) {
        this.searchFn()
      }
    },
    callSuccessFn(handle, res) {
      if (this.isXiAn) {
        this.searchFn()
      }
      //上传成功回调父组件方法
      if (this.$parent[handle]) {
        this.$parent[handle].call(this.$parent, res);
        return;
      }

      if (this.$parent.$parent[handle]) {
        this.$parent.$parent[handle].call(this.$parent.$parent, res);
        return;
      }
      if (this.$parent.$parent.$parent[handle]) {
        this.$parent.$parent.$parent[handle].call(
          this.$parent.$parent.$parent,
          res
        );
      } else {
      }
    },
    getCascaderProp(item) {
      if (item.props && !item.props.emitPath && !item.props.value) {
        item.props.value = "svalue";
        return item.props;
      }
      return item.props || {};
    },
    handleStartInput() {
      this.numberAreaCheck(1);
    },
    handleEndChange() {
      this.numberAreaCheck(2);
    },
    numberAreaCheck(val) {
      // 数字区间校验
      let { startBind, endBind } = this.getBind(
        this.search.config,
        "numberArea"
      )
        ? this.getBind(this.search.config, "numberArea")
        : {};
      let start = this.search.formData[startBind];
      let end = this.search.formData[endBind];
      const isEmpty = null || undefined || "";
      if (isEmpty != start && isEmpty != end && Number(start) > Number(end)) {
        if (val == 1) {
          this.search.formData[endBind] = Number(start);
        } else {
          this.search.formData[startBind] = Number(end);
        }
      }
    },
    getBind(arr, name, key = "type") {
      return arr.find((item) => item[key] == name);
    },
    searchFn(e) {
      this.$emit("queryList");
    },

    resetForm() {
      this.$refs[this.search.name || "form"].resetFields();
      this.search.config.forEach((item) => {
        if (item.type == "numberArea") {
          this.search.formData[item.startBind] = "";
          this.search.formData[item.endBind] = "";
        }
      });
      this.searchFn();
    }
  },
};
</script>
<style lang="scss" scoped>
.sr_search {
  .default_number_area {
    display: flex;
    .interval {
      padding: 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// packages/SrSearch/index.vue